export const LANG_CHANGE = 'LANG_CHANGE';
export const MEDICINE_SEARCH_BY_LETTER = 'MEDICINE_SEARCH_BY_LETTER';
export const MEDICINE_SEARCH_BY_NAME = 'MEDICINE_SEARCH_BY_NAME';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SET_USER_JUST_LOGGED_TO_FALSE = 'SET_USER_JUST_LOGGED_TO_FALSE';
export const SET_USER_NOTIFICATIONS = 'SET_USER_NOTIFICATIONS';
export const NOTIFICATION_ADDED = 'NOTIFICATION_ADDED';
export const MEDICINE_SEARCH_BY_ACTIVE_INGREDIENT = 'MEDICINE_SEARCH_BY_ACTIVE_INGREDIENT';
